<script>
  import { onMount } from "svelte";
  import {ignore, makeWebsiteRequest} from "../../../Common/tools";
  import {External, M} from "../../../external";

  export let data;
  export let valid;
  export let onChange = ignore;

  let automations = [];
  let selectedAutomations = [];

  const onAutomationsSelected = (automations) => {
    selectedAutomations = automations;
    if (selectedAutomations) {
      data.settings = [];
      selectedAutomations.forEach((setting) => {
        data.settings.push(setting);
      });
      data.name = selectedAutomations.map((setting) => setting.value).join(", ");
    }
    valid = selectedAutomations.length > 0;
    onChange();
  };

  async function load() {
    let response = await makeWebsiteRequest({
      action: "getAutomations",
      data: {
        skip: 0,
        limit: 30,
        withStats: false
      }
    });

    let items = response.data.items;
    automations = [];
    items.forEach(function (item) {
      automations.push({ key: item.id + "", value: item.name + "" });
    });

    if (data && data.settings) {
      data.settings.forEach((setting) => {
        selectedAutomations.push(setting);
      });
    }

    valid = selectedAutomations.length > 0;
    selectedAutomations = selectedAutomations;
  }

  let click = () => {
    External.Tools.chooseMultiple({
      title: M.AUTOMATIONS,
      message: M.SELECT_AUTOMATIONS,
      noItemsMessage: M.NO_AVAILABLE_AUTOMATIONS,
      items: automations,
      selectedItems: selectedAutomations,
      isModal: true,
      getItemId: function (element) {
        return element.key;
      },
      getItemText: function (element) {
        return element.value;
      },
      onSelect: onAutomationsSelected
    });
  };

  onMount(load);
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.START_ANOTHER_AUTOMATION}</h4>
  <div class="f-left col20 multiple-items-picker mt-15 mb-5">
    <ul class="groups category-groups mb-15">
      <li>
        <a on:click={click} class="middle-button gray">{M.SELECT_AUTOMATION}</a>
      </li>
      <li data-role="count">{selectedAutomations.length} {M.SELECTED}</li>
    </ul>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
